module.exports = __webpack_public_path__ + "static/media/26-WaterHeatExchanger - Water cool - No heat.72551c9c.png";